(ns app.front.view.admin.audit-log
  (:require [app.domain.workspace.model :as workspace-model]
            [app.front.ui :as ui]
            [app.front.ui.section :as section]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil :refer [for-all for-frag]]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.user.model :as user-model]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))


(rf/reg-event-fx ::fetch-log
  (fn [_ [_ workspace-id]]
    {:comm/command {:command    :admin/audit-log
                    :method     :get
                    :data       {:workspace-id workspace-id}
                    :on-success [::fetch-log.success workspace-id]}}))

(rf/reg-event-fx ::fetch-email-log
  (fn [_ [_ workspace-id]]
    {:comm/command {:command    :admin/email-log
                    :method     :get
                    :data       {:workspace-id workspace-id}
                    :on-success [::fetch-email-log.success workspace-id]}}))

(rf/reg-event-fx ::fetch-email-log-email
  (fn [{:keys [db]} [_ email-id]]
    {:db           (-> db
                       (assoc-in [::emails email-id] :loading))
     :comm/command {:command    :admin/email-log-email
                    :method     :get
                    :data       (util/mmap email-id)
                    :on-success [::fetch-email-log-email.success email-id]}}))


(rf/reg-event-db ::fetch-log.success
  (fn [db [_ workspace-id _ txs]]
    (assoc-in db [::audit-log workspace-id] txs)))

(rf/reg-event-db ::fetch-email-log.success
  (fn [db [_ workspace-id _ mails]]
    (assoc-in db [::email-log workspace-id] mails)))

(rf/reg-event-db ::fetch-email-log-email.success
  (fn [db [_ email-id _ content]]
    (assoc-in db [::emails email-id] (if-not (empty? content)
                                       content
                                       :not-available))))

(rf/reg-event-db ::save-workspace-id
  (fn [db [_ workspace-id]]
    (assoc db ::workspace-id workspace-id)))


(rf/reg-sub ::audit-log
  (fn [db [_ workspace-id]]
    (get-in db [::audit-log workspace-id])))

(rf/reg-sub ::email-log
  (fn [db [_ workspace-id]]
    (get-in db [::email-log workspace-id])))

(rf/reg-sub ::single-email
  (fn [db [_ email-id]]
    (get-in db [::emails email-id])))


(rf/reg-sub ::workspace-id
  (fn [db _]
    (some-> db ::workspace-id str/trim)))

(defn user-col [{:keys [:db/id :user/username] :as user}]
  (cc/link
    {:href (href/href :view/admin.entity-lookup-with-param {:search-term id})}
    (futil/str-and-desc (user-model/full-name user) username)))

(defn header [title content]
  [:div.font-mono.flex.mt-1 [:span.bold.mr-2.w-32.flex-none title ": "] [:div.flex-1 content]])

(defn view [_]
  (let [tr               (<sub [:tr])
        workspace-id     (<sub [::workspace-id])
        format-date-time (<sub [::date-util/date-time-fn])]
    [:div.cloudpermit-page.admin-page
     [:div.bx--row.page-heading
      [:h1.bx--col-xs-12 (tr [:admin.audit-log/application-audit-log])]]
     [:section.bx--row.items-end
      [:div.bx--col-xs-9.bx--col-md-6.bx--col-lg-4.bx--col-xxl-3
       [ui/text-input {:id          "entity-lookup-id"
                       :value       workspace-id
                       :on-change   #(rf/dispatch-sync [::save-workspace-id (futil/tval %)])
                       :placeholder (tr [:placeholder/application-id])
                       :label-text  (tr [:admin.audit-log/workspace-id])}]]
      [:div.bx--col-xs-3.bx--col-md-3.bx--col-xl-2.flex.gap-2
       (cc/button {:kind     :primary
                   :disabled (not (workspace-model/workspace-id? workspace-id))
                   :on-click #(>evt [::fetch-log workspace-id])}
                  "Retrieve audit log")
       (cc/button {:kind     :primary
                   :icon     i/envelope
                   :disabled (some? (s/check workspace-model/WorkspaceId workspace-id))
                   :on-click #(>evt [::fetch-email-log workspace-id])}
                  "Retrieve email log")]]
     (when-let [app-id (when (workspace-model/workspace-id? workspace-id)
                         workspace-id)]
       [:section
        [:h3 workspace-id]
        (when-let [mails (<sub [::email-log app-id])]
          [section/subsection
           {:title "Sent emails related to this workspace"}
           [:ul
            (for-all [{:entity/keys [created] :db/keys [id]} mails]
              ^{:key id}
              [:li.flex.flex-col.mt-4
               [header (tr [:email-log/date]) (format-date-time created)]
               (let [email (<sub [::single-email id])]
                 (case email
                   :loading
                   (cc/loading-spinner {:with-overlay false :small true})

                   :not-available
                   [:div.mt-2
                    "Email content not available"]

                   nil
                   [:button {:on-click #(>evt [::fetch-email-log-email id])}
                    "Show contents"]

                   ;;default
                   (let [{:keys [name address subject body attachments external-id]} email]
                     [:div
                      [header (tr [:email-log/to]) (str name " <" address ">")]
                      [header (tr [:email-log/subject]) subject]
                      [header "External ID" external-id]
                      (when (seq attachments)
                        [header "Attachments"
                         [:ul (for-frag [{:keys [filename]} attachments] [:li filename])]])
                      [:iframe.w-full.h-80 {:srcdoc body}]])))])]])
        (when-let [txes (<sub [::audit-log app-id])]
          [section/subsection
           {:title (tr [:admin.audit-log/tx-from-old-to-new])}
           [ui-table/modern-responsive-table
            (util/mmap {:items txes
                        :link  {:description "Open entity lookup"
                                :make-href   #(href/href :view/admin.entity-lookup-with-param
                                                         {:search-term (:db/id %)})}
                        :cols  [["Time"
                                 (comp #(.toISOString %) :db/txInstant)
                                 {:width "220px"}]
                                ["Command" (comp str :audit/command)]
                                ["User" (comp user-col :audit/user)]
                                ["Signal" :audit/signal]]}
                       tr)]])])]))


(def route
  {:name :view/admin.audit-log
   :view view})
